module.exports = {
  name: 'x-profile-nationality',
  view: require('./view.html'),
  observedAttributes: ['code']
}
